<template>
  <div class="w100 Contenido">
    <Titulo :seccion="datos.title" :icon="datos.icon" />
    <Descripcion>{{ datos.description }}</Descripcion>
    <Tabla
      :nombre="datos.routeName"
      :id-herramienta="datos.id"
      :columnas="columnasTabla"
    />
    <i class="fa-thin fa-user"></i>
  </div>
</template>

<script>
import { ColumnasTabla } from "../../Auxiliares/Enums";

export default {
  name: "ManagerPdfTool",
  props: {
    datos: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      columnasTabla: [
        ColumnasTabla.Productor,
        ColumnasTabla.Establecimiento,
        ColumnasTabla.Localidad,
      ],
    };
  }
};
</script>
